import React from 'react';

export default function RaceApp() {
  return <h1 className="race-name">Race App</h1>;
}
